module.exports = __webpack_public_path__ + "src/assets/games/61/nan.gif";